import { Component } from '@angular/core';

@Component({
  selector: 'ui-menu-list',
  templateUrl: './menu-list.html',
})
export class MenuList {}
